import React, { useState, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { formatInTimeZone } from 'date-fns-tz';
import CountryFlag from '../common/CountryFlag';
import './WorldClock.css';

const COUNTRY_TIMEZONES = {
  US: 'America/New_York',
  DO: 'America/Santo_Domingo',
  TN: 'Africa/Tunis',
  CO: 'America/Bogota',
  VE: 'America/Caracas',
  AR: 'America/Argentina/Buenos_Aires',
  PT: 'Europe/Lisbon',
};

function WorldClock({ countries }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(interval);
  }, []);

  if (!countries || countries.length === 0) {
    return null;
  }

  return (
    <div className="world-clock">
      <div className="world-clock-header">
        <Globe size={16} strokeWidth={2} />
        <h3>World Clock</h3>
      </div>
      <div className="world-clock-grid">
        {countries.map((country) => {
          const tz = country.timezone || COUNTRY_TIMEZONES[country.code];
          if (!tz) return null;

          const time = formatInTimeZone(now, tz, 'h:mm a');
          const tzAbbr = formatInTimeZone(now, tz, 'zzz');

          return (
            <div key={country.code} className="world-clock-item">
              <CountryFlag code={country.code} size="medium" />
              <span className="world-clock-name">{country.name}</span>
              <div className="world-clock-time-group">
                <span className="world-clock-time">{time}</span>
                <span className="world-clock-tz">{tzAbbr}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default WorldClock;
